import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=b88c38d2&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c38d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88c38d2')) {
      api.createRecord('b88c38d2', component.options)
    } else {
      api.reload('b88c38d2', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=b88c38d2&scoped=true", function () {
      api.rerender('b88c38d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/tenantManager/edit.vue"
export default component.exports